export class PostalCodeValidator {
    constructor() {
        // Regex for norsk postnummer (4 siffer)
        this.postalCodePattern = /^\d{4}$/;
        this.modal = document.querySelector('[data-component="service-guide-modal"]');
        this.input = this.modal.querySelector('#postal-code');
        this.errorMessage = this.modal.querySelector('.error-message');
    }

    validate(value) {
        if(value === undefined || value === null) {
            this.updateUI('error');
            return false;
        }
        
        // Fjern ikke-numeriske tegn
        const cleanValue = value?.replace(/\D/g, '');

        if (cleanValue.length === 0) {
            this.updateUI('normal');
            return false;
        }
        
        if (cleanValue.length < 4 || cleanValue.length > 5) {
            this.updateUI('error');
            return false;
        }
        
        this.updateUI('valid');
        return true;
    }

    updateUI(state) {
        switch (state) {
            case 'normal':
                this.input.classList.remove('error');
                this.errorMessage.textContent = '';
                this.errorMessage.style.visibility = 'hidden';
                this.errorMessage.removeAttribute('role');
                break;

            case 'valid':
                this.input.classList.remove('error');
                this.errorMessage.textContent = '';
                this.errorMessage.style.visibility = 'hidden';
                this.errorMessage.removeAttribute('role');
                break;

            case 'error':
                this.input.classList.add('error');
                this.errorMessage.textContent = this.modal.dataset.errorPostalCode;
                this.errorMessage.style.visibility = 'visible';
                this.errorMessage.setAttribute('role', 'alert');
                break;
        }
    }

    isValidPostalCodeFormat(postalCode) {
        return this.postalCodePattern.test(postalCode);
    }

    sanitizeInput(value) {
        return value.replace(/\D/g, '').slice(0, 4);
    }

    formatInput(value) {
        // Hvis vi vil legge til formatering senere (f.eks. mellomrom)
        return this.sanitizeInput(value);
    }
}